import {WsCustomerSortField} from '@lifeislife/lifeislife-ws-api';

// Export type and value to access constants
export type CustomerSortField = WsCustomerSortField;
export const CustomerSortField = WsCustomerSortField;
